module.exports = __webpack_public_path__ + "static/media/d3.d9a99bed.svg";